module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/buying-medium-97515e02fcaa4490ae637a403edffc31.svg";